module.exports = __webpack_public_path__ + "static/media/foto3.d1740d70.JPG";